import { Inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import Env from '@ridango/core/env';

@Injectable()
export class RedirectGuard implements CanActivate {
    constructor(
        @Inject('ENV') private env: Env,
        private router: Router,
        private translate: TranslateService
    ) {}

    canActivate() {
        if (this.env.DEFAULT_REDIRECT_AFTER_LOGIN && Array.isArray(this.env.DEFAULT_REDIRECT_AFTER_LOGIN)) {
            this.router.navigate([this.translate.currentLang, ...this.env.DEFAULT_REDIRECT_AFTER_LOGIN]);
        } else if (this.env.USE_TAILWIND && this.env.ACCOUNT.ACTIONS.includes('cards')) {
            this.router.navigate([this.translate.currentLang, 'account', 'cards']);
        } else {
            this.router.navigate([this.translate.currentLang, 'account', 'related-cards']);
        }
        return true;
    }
}
